export default __webpack_public_path__ + "static/media/Group 8152.82c1b986.png";